export const LEASING_HISTORY_KEY = 'radar_leasing_history_v1'
export const LEASING_HISTORY_MAX = 10

export function loadLeasingHistory() {
  try {
    const raw = localStorage.getItem(LEASING_HISTORY_KEY)
    const arr = JSON.parse(raw || '[]')
    return Array.isArray(arr) ? arr : []
  } catch {
    return []
  }
}

export function persistLeasingHistory(entries) {
  try {
    localStorage.setItem(LEASING_HISTORY_KEY, JSON.stringify(entries))
  } catch {
    /* quota */
  }
}
